// extracted by mini-css-extract-plugin
export var slideshow = "InformationSlideShow-module--slideshow--10484";